import React from 'react'
import PropTypes from 'prop-types'
import HeaderLinks from './header-links'

const HeaderLinksFormatted = ({ className }) => {
  return (
    <span className={className}>
      <HeaderLinks />
    </span>
  )
}

HeaderLinksFormatted.propTypes = {
  className: PropTypes.string.isRequired,
  primary: PropTypes.bool.isRequired,
}

export default HeaderLinksFormatted
